import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { IEdificios } from '../interfaces/Edificios';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RegistroVentasService } from '../Services/registro-ventas.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';
import Swal from 'sweetalert2';
import { IMonitorVentas } from '../interfaces/MonitorVentas';
import { IFiltrosMonitor } from '../interfaces/FiltrosMonitor';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-monito-registroventas',
  templateUrl: './monito-registroventas.component.html',
  styleUrls: ['./monito-registroventas.component.css']
})
export class MonitoRegistroventasComponent implements OnInit {

  edificios: Array<IEdificios>;
  term: string;
  dia:Date;
  edificio: string;
  formMonitor: FormGroup;
  resultadoConsulta: IMonitorVentas[];
  submitted = false;
  formatedDate : any;

  constructor( private registroServicios: RegistroVentasService,
    private readonly formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.getEdificiosRegistro(environment.edificiosAutorizados, environment.marcasAutorizadas);
   this.construirFromularioRegistro();
  
  }

  construirFromularioRegistro() {
    this.formMonitor = this.formBuilder.group({
      edificio: ['', Validators.required],
      dia: ['']
    });
  }

 /* get f() { return this.formMonitor.controls; }*/

   getEdificiosRegistro(edificios: string, marcas: string) {

    this.registroServicios.getEdificiosRegistro(edificios, marcas).subscribe(
      resolve => {
        if (resolve.length != 0) {
          this.edificios = resolve;
        }

      },
      (error: ErrorResponse) => {
        console.log(error);
      }
    );
  }

  getMonitorVentas() {
    this.spinner.show();
    const filtros: IFiltrosMonitor = {
      ...this.formMonitor.value
    };

  /* var diaSeleccionado = this.formMonitor.controls["dia"].value;
    this.formatedDate =  this.datePipe.transform(diaSeleccionado, "yyyy-MM-dd");
    this.formMonitor.controls["dia"] =  diaSeleccionado == undefined ||  diaSeleccionado == "" ? this.formatedDate: diaSeleccionado;*/
    var diaSeleccionado = this.dia;
    
    
    this.formatedDate =  this.datePipe.transform(diaSeleccionado, "yyyy-MM-dd");
    filtros.Dia =   diaSeleccionado == undefined ||  diaSeleccionado == null ? this.formatedDate: diaSeleccionado;
    filtros.Edificio = this.edificio;
    this.registroServicios.getMonitorVentas(filtros).subscribe(
      resolve => {
        if(resolve.length != 0)
        {
          this.resultadoConsulta = resolve; 
          this.spinner.hide();
      }
      else{
        Swal.fire('No se encontraron registros.');
        this.spinner.hide();
      }
    },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  }

}
